import * as Sentry from '@sentry/react'
import { httpClientIntegration, dedupeIntegration } from '@sentry/integrations'

import { isClub } from 'common/helpers/interceptor'

const SENTRY_DSN = process.env.SENTRY_DSN
const SENTRY_ENV = process.env.SENTRY_ENV

Sentry.init({
  beforeSend: event => {
    return event
  },

  initialScope: scope => {
    scope.setTags({
      isClub: isClub()
    })
    return scope
  },
  dsn: SENTRY_DSN,
  integrations: [httpClientIntegration(), dedupeIntegration()],
  autoSessionTracking: true,
  environment: SENTRY_ENV,
  sampleRate: 0.5,
  attachStacktrace: true,
  sendDefaultPii: true
})
